export default __webpack_public_path__ + "static/media/jieshou.2a6d9741.svg";